import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import * as api from "../api/client";
import { usePolledResource } from "../hooks/usePolling";
import { ServerCard } from "../components/ServerCard";
import type { HealthState } from "../types";

const POLL_INTERVAL_MS = 20_000;
type Filter = HealthState | "all";

export function Servers() {
  const { data, loading, error } = usePolledResource(api.listServers, POLL_INTERVAL_MS);
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState<Filter>("all");

  const servers = data?.servers ?? [];

  const filtered = useMemo(() => {
    return servers.filter((s) => {
      if (filter !== "all" && s.health_state !== filter) return false;
      if (query.trim().length === 0) return true;
      const q = query.toLowerCase();
      return s.display_name.toLowerCase().includes(q) || s.id.toLowerCase().includes(q);
    });
  }, [servers, query, filter]);

  return (
    <>
      <div className="topbar">
        <div className="page-title-group">
          <h1>Servers</h1>
          <p>Every server registered with this deployment.</p>
        </div>
        <Link to="/generator" className="btn btn-primary">
          Generate a server
        </Link>
      </div>

      <div className="row" style={{ marginBottom: "var(--space-5)", flexWrap: "wrap" }}>
        <input
          className="input"
          style={{ maxWidth: "260px" }}
          placeholder="Search by name or ID…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <div className="btn-row">
          {(["all", "normal", "degraded", "offline"] as Filter[]).map((f) => (
            <button
              key={f}
              type="button"
              className={`btn btn-sm ${filter === f ? "btn-primary" : ""}`}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? "All" : f[0].toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {error && <div className="form-error">{error}</div>}

      {loading ? (
        <p className="muted">Loading servers…</p>
      ) : filtered.length === 0 ? (
        <div className="empty-state">
          <p>No servers match this view.</p>
        </div>
      ) : (
        <div className="server-grid">
          {filtered.map((server) => (
            <ServerCard key={server.id} server={server} />
          ))}
        </div>
      )}
    </>
  );
}
